import ReactECharts from 'echarts-for-react';

interface PieChartProps {
  data: Array<{ name: string; value: number; color?: string }>;
  height?: number;
  donut?: boolean;
}

const COLORS = ['#6366f1', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#ec4899', '#14b8a6'];

export function PieChart({ data, height = 260, donut = true }: PieChartProps) {
  const option = {
    tooltip: { trigger: 'item', backgroundColor: 'rgba(30,30,40,0.95)', borderColor: 'rgba(255,255,255,0.1)', textStyle: { color: '#e5e5e5' } },
    legend: { orient: 'vertical' as const, right: 8, top: 'middle', textStyle: { color: 'rgba(255,255,255,0.6)', fontSize: 11 } },
    color: data.map((d, i) => d.color || COLORS[i % COLORS.length]),
    series: [{
      type: 'pie',
      radius: donut ? ['40%', '68%'] : ['0%', '68%'],
      center: ['35%', '50%'],
      data,
      label: { show: false },
      emphasis: { label: { show: true, fontSize: 13, fontWeight: 'bold', color: '#fff' } },
    }],
  };

  return <ReactECharts option={option} style={{ height }} notMerge lazyUpdate />;
}
